const actualBtn = document.querySelectorAll('.file-upload')
const fileChosen = document.querySelectorAll('.file-chosen')
const resetBtn = document.querySelectorAll('.reset-upload')

if (typeof (actualBtn) !== 'undefined' && actualBtn !== null) {
  actualBtn.forEach((element, i) => {
    element.setAttribute('hidden', 'hidden')
    element.addEventListener('change', () => {
      fileChosen[i].textContent = element.files[0].name
      resetBtn[i].classList.add('show')
    })
    resetBtn[i].addEventListener('click', () => {
      resetBtn[i].classList.remove('show')
      element.value = ''
      fileChosen[i].textContent = ''
    })
  })
}

/* eslint-disable */
const $buoop = {
  required: {
    e: -4,
    f: -3,
    o: -3,
    s: -1,
    c: -3
  },
  insecure: true,
  api: 2020.12
}

function $buo_f () {
  var e = document.createElement('script')
  e.src = '//browser-update.org/update.min.js'
  document.body.appendChild(e)
}
try {
  document.addEventListener('DOMContentLoaded', $buo_f, false)
} catch (e) {
  window.attachEvent('onload', $buo_f)
}
/* eslint-enable */
